import { default as index } from './zh_HK/index';

export default Object.assign(
  {
    locale: 'zh_HK',
    pluralRuleFunction: () => {
      return 'other';
    }
  },
  index
);



// WEBPACK FOOTER //
// ./src/i18n/zh-HK.js